import React, { useRef, useState } from 'react';
import cx from 'classnames';

import { LightTooltip } from '../LightTooltip';
import useStyles from './styles';

interface ProgressLineProps {
  width?: number;
  wrapperClass?: string;
  lineClass?: string;
  tooltipText?: string;
}

const ProgressLine: React.FC<ProgressLineProps> = ({
  width = 0,
  wrapperClass = '',
  lineClass = '',
  tooltipText = '',
}) => {
  const classes = useStyles();

  const [offset, setOffset] = useState(0);

  const wrapperRef = useRef<HTMLDivElement>(null);

  const handleMouseEnter = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    if (wrapperRef?.current) {
      const center = wrapperRef.current.clientWidth / 2;
      const clientX = event.clientX;
      const elX = wrapperRef.current.getBoundingClientRect().x;
      const mouseXPosOnEl = clientX - elX;

      setOffset(mouseXPosOnEl - center);
    }
  };

  return tooltipText ? (
    <LightTooltip
      placement="top"
      title={tooltipText}
      classes={{ tooltip: classes.tooltip }}
      PopperProps={{
        popperOptions: {
          modifiers: {
            offset: {
              enabled: true,
              offset: `${offset}px, 0px`,
            },
          },
        },
      }}
    >
      <div ref={wrapperRef} onMouseEnter={handleMouseEnter}>
        <div className={cx(classes.wrapper, wrapperClass)} />
        <div className={cx(classes.line, lineClass)} style={{ width: `${width}%` }} />
      </div>
    </LightTooltip>
  ) : (
    <>
      <div className={cx(classes.wrapper, wrapperClass)} />
      <div className={cx(classes.line, lineClass)} style={{ width: `${width}%` }} />
    </>
  );
};

export default ProgressLine;
